import { render, staticRenderFns } from "./examsAnalyse.vue?vue&type=template&id=5b1ef52e"
import script from "./examsAnalyse.vue?vue&type=script&lang=js"
export * from "./examsAnalyse.vue?vue&type=script&lang=js"
import style0 from "./examsAnalyse.vue?vue&type=style&index=0&id=5b1ef52e&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports